export default {
  live: (state) => state.live,
  liveGame: (state) => state.liveGame,
  lottery: (state) => state.lottery,
  token: (state) => state.app.token,
  notice: (state) => state.app.notice,
  appConfig: (state) => state.app.appConfig,
  uid: (state) => state.app.uid,
  userInfo: (state) => state.app.userInfo || {},
};
